import { Component, Input } from '@angular/core';
import { OcrPlusComponent } from '../ocr-plus/ocr-plus.component';
import { APIService } from 'src/app/API.service';
import { Auth } from 'aws-amplify';
// import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-chat-gpt-container',
  templateUrl: './chat-gpt-container.component.html',
  styleUrls: ['./chat-gpt-container.component.css'],
})
export class ChatGptContainerComponent {
  @Input() ocrPlus: OcrPlusComponent;

  userMessage: string = '';
  assistantMessage: string = '';
  messages: any[] = [];
  user: any;
  token: any;
  loadingFlag: boolean;
  init: any;
  messagesBase: { role: string; content: string }[];
  chatId: string;
  chatAgent = "claude"//"gpt" //
  systemPrompt: string;
  docText: any;
  separator: string = "\n===============================\n";

  constructor(
    private api: APIService
  ) {
    this.chatId = Math.random().toString(36).substr(2, 9);

  }

  async ngOnInit() {
    this.user = await Auth.currentUserInfo();

    if (this.user) this.token = await this.api.GetTokens(this.user.username);
  }
  ngAfterViewInit() {
    this.restart();
  }

  restart() {
    this.init = false;
    this.systemPrompt = `You are a helpful assistant, the query will provide snippets of a document in markdown format.
    Note, that the source of the document a PDF or OCR result of a scanned document.
    therefore the text might contain typos and other errors. 
    please ignore them and try to understand the meaning of the text.
    `
    this.messages = []
    this.assistantMessage = '';

  }

  ngAfterViewChecked() {
    if (!this.init) {
      if (this.ocrPlus && this.ocrPlus.jsonData && this.ocrPlus.jsonData.data) {
        let docText = this.ocrPlus.jsonData.data
          .map((item) => item.text)
          .join('\n');
        const MAX_LENGTH = 25000;
        // trim html to max MAX_LENGTH chars
        if (docText.length > MAX_LENGTH) {
          docText = docText.substring(0, MAX_LENGTH) + '...';
        }
        this.init = true;
        this.docText = docText
        // this.messagesBase.push({
        //   role: 'system',
        //   content: joinedText,
        // });
        // this.messages.push({
        //   role: 'system',
        //   content: joinedText,
        // });
        this.userMessage = '';
      }
    }
  }

  scrollToBottom(): void {
    const elem = document.getElementsByClassName('upload-col');
    elem[0].scroll({
      left: 0,
      top: elem[0].scrollHeight,
      behavior: 'smooth',
    });
  }

  sendMessage() {
    if (this.userMessage.length == 0) return;
    let messageBuff:any = []
    let userMsg = this.systemPrompt + this.separator
    userMsg+= this.docText+this.separator
    messageBuff.push({
      role: 'user',
      content: userMsg,
    });    

    if (this.assistantMessage.length > 0) {
      messageBuff.push({
        role: 'assistant',
        content: this.assistantMessage,
      });
      this.messages.push({
        role: 'assistant',
        content: this.assistantMessage,
      })
    } else {
      messageBuff.push({
        role: 'assistant',
        content: "Please ask a question about the document"
      });
    } 
      

    messageBuff.push({
      role: 'user',
      content: this.userMessage,
    });
    this.messages.push({
      role: 'user',
      content: this.userMessage,
    })    
    const messages = { messages: messageBuff, chatId: this.chatId };
    const messageJsonStr = JSON.stringify(messages);
    // console.log('messageJsonStr', messageJsonStr.length);

    this.assistantMessage = '';
    this.userMessage = '';
    this.readStreamedResponse(messageJsonStr);
  }



  async readStreamedResponse(messageJsonStr) {
    // const gptStreamUrl = environment.gptStreamUrl+"gpt";
    const gptStreamUrl = environment.gptStreamUrl+this.chatAgent;
    const response = await fetch(gptStreamUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: messageJsonStr, // Convert the array or object to a JSON string
    });

    if (!response.body) {
      console.log("The browser doesn't support ReadableStream!");
      return;
    }

    const reader = response.body.getReader();

    const that = this;
    // This is a simple example to read and process the streamed data in text format.
    const stream = new ReadableStream({
      async start(controller) {
        while (true) {
          const { done, value } = await reader.read();

          if (done) {
            break;
          }

          // Convert the data from Uint8Array to a string.
          const textChunk = new TextDecoder().decode(value);
          that.assistantMessage += textChunk;

          controller.enqueue(value);
        }

        controller.close();
      },
    });

    const newResponse = new Response(stream, {
      headers: { 'Content-Type': 'text/plain' },
    });
    const result = await newResponse.text();

    console.log(result);
  }

}
